import axiosInstance from "../../../helpers/api";

export const getAllQuestionsBank = (id) => {
  return axiosInstance.get(`/superadmin/bank-questions?course_id=${id}`);
};

export const getQuestionBankByBucket = (id) => {
  return axiosInstance.get(`/superadmin/bank-questions?bucket_id=${id}`);
};

export const editQuestionBank = (formData) => {
  return axiosInstance.post(
    `/superadmin/bank-questions/${formData.id}`,
    formData.formData
  );
};

export const createQuestionBank = (formData) => {
  return axiosInstance.post("/superadmin/bank-questions", formData);
};

export const deleteQuestionBank = (id) => {
  return axiosInstance.delete(`/superadmin/bank-questions/${id}`);
};

export const bookmarkQuestionBank = (id) => {
  return axiosInstance.get(`/superadmin/bank-questions/book_mark/${id}`);
};
